<template>
    <div class="main-header con-wrapper">
        <div class="wrapper">
            <div class="logo-con">
                <router-link :to="{ name: 'home' }">
                    <img class="img-responsive" :src="`${icdn_url}/desktop-logo.png`" :alt="`Logo ${site_name}`" v-cloak>
                </router-link>
            </div>
            <div class="login-con" v-if="!isAuthenticated">
                <span>{{ 'Already a member?' | translate }}</span>
                <div class="btn-con">
                    <button class="btn btn-login" @click="$router.push({ name: 'login' })">
                        <span>{{ 'Login' | translate }}</span>
                    </button>
                </div>
            </div>
            <div class="user-nav" v-if="isAuthenticated">
                <div class="btn-con">
                    <button class="btn btn-credits" @click="$router.push({ name: 'user-credits' })">
                        <span>{{ 'Get Credits' | translate }}</span>
                        <i class="icon icon-credits-white"></i>
                    </button>

                    <button class="btn btn-white-orange btn-logout" @click="() => { this.open_logout_confirm = !this.open_logout_confirm }">
                        <span>{{ 'Log out' | translate }}</span>
                        <svg-lock class="svg-icon" :width="18" :height="18"></svg-lock>
                    </button>

                    <logout-confirm
                        v-if="open_logout_confirm"
                        @close="() => { this.open_logout_confirm = false }"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MainHeader from '@views/common/MainHeader/main_header'
    import SvgLock from '@theme-views/common/SvgIcon/Icons/Lock'
    import LogoutConfirm from '@theme-views/common/MainHeader/partials/LogoutConfirm'

    export default {
        mixins: [MainHeader],
        components: { SvgLock, LogoutConfirm }
    }
</script>

<style lang="scss" src="./main_header.scss"></style>
